import { SET_MENU_SUBTEXT } from 'common/constants/action-types';

export interface IMenu {
  subText?: string;
}

const INITIAL_STATE: IMenu = {
  subText: undefined
};
export default function (state = INITIAL_STATE, action: any) {
  switch (action.type) {
    case SET_MENU_SUBTEXT:
      return {
        ...state,
        subText: action.payload
      };
    default:
      return state;
  }
}
